import * as actionTypes from "./actionTypes";

export const checkEmail = email => ({
    type: actionTypes.CHECK_EMAIL,
    email
});

export const checkEmailSucceeded = (step, hash, timer, alreadyRegistered) => ({
    type: actionTypes.CHECK_EMAIL_SUCCEEDED,
    step,
    hash,
    timer,
    alreadyRegistered,
});

export const checkEmailFailed = validationErrors => ({
    type: actionTypes.CHECK_EMAIL_FAILED,
    validationErrors
});

export const verifyEmail = code => ({
    type: actionTypes.VERIFY_EMAIL,
    code
});

export const verifyEmailSucceeded = (step, hash) => ({
    type: actionTypes.VERIFY_EMAIL_SUCCEEDED,
    step,
    hash
});

export const verifyEmailFailed = validationErrors => ({
    type: actionTypes.VERIFY_EMAIL_FAILED,
    validationErrors
});

export const fillProfile = payload => ({
    type: actionTypes.FILL_PROFILE,
    payload
});

export const fillProfileSucceeded = userToken => ({
    type: actionTypes.FILL_PROFILE_SUCCEEDED,
    userToken
});

export const fillProfileFailed = validationErrors => ({
    type: actionTypes.FILL_PROFILE_FAILED,
    validationErrors
});

export const verifyPassword = password => ({
    type: actionTypes.VERIFY_PASSWORD,
    password
});

export const verifyPasswordSucceeded = userToken => ({
    type: actionTypes.VERIFY_PASSWORD_SUCCEEDED,
    userToken
});

export const verifyPasswordFailed = validationErrors => ({
    type: actionTypes.VERIFY_PASSWORD_FAILED,
    validationErrors
});

export const resetStep = () => ({
    type: actionTypes.RESET_STEP
});

export const requestPasswordReset = () => ({
    type: actionTypes.REQUEST_PASSWORD_RESET
});

export const requestPasswordResetSucceeded = () => ({
    type: actionTypes.REQUEST_PASSWORD_RESET_SUCCEEDED
});

export const requestPasswordResetFailed = validationErrors => ({
    type: actionTypes.REQUEST_PASSWORD_RESET_FAILED,
    validationErrors
});

export const requestPasswordResetRedirected = () => ({
    type: actionTypes.REQUEST_PASSWORD_RESET_REDIRECT
});

export const resetPassword = (token, newPassword) => ({
    type: actionTypes.RESET_PASSWORD,
    token,
    newPassword
});

export const resetPasswordSucceeded = () => ({
    type: actionTypes.RESET_PASSWORD_SUCCEEDED
});

export const resetPasswordFailed = (validationErrors, resetPasswordError) => ({
    type: actionTypes.RESET_PASSWORD_FAILED,
    validationErrors,
    resetPasswordError
});

export const resetPasswordDismissError = () => ({
    type: actionTypes.RESET_PASSWORD_DISMISS_ERROR
});

export const restoreSession = () => ({
    type: actionTypes.RESTORE_SESSION
});

export const restoreSessionSucceeded = userToken => ({
    type: actionTypes.RESTORE_SESSION_SUCCEEDED,
    userToken
});

export const logout = () => ({
    type: actionTypes.LOGOUT
});

export const logoutSucceeded = () => ({
    type: actionTypes.LOGOUT_SUCCEEDED
});

export const requestResetPasswordCode = () => ({
    type: actionTypes.REQUEST_RESET_PASSWORD_CODE,
});

export const requestResetPasswordCodeSuccess = ({ step, timer }) => ({
    type: actionTypes.REQUEST_RESET_PASSWORD_CODE_SUCCESS,
    step,
    timer,
});

export const requestResetPasswordCodeFail = () => ({
    type: actionTypes.REQUEST_RESET_PASSWORD_CODE_FAIL,
});

export const verifyResetPasswordCode = ({ code }) => ({
    type: actionTypes.VERIFY_RESET_PASSWORD_CODE,
    payload: { code },
});

export const verifyResetPasswordCodeSuccess = ({ step }) => ({
    type: actionTypes.VERIFY_RESET_PASSWORD_CODE_SUCCESS,
    step,
});

export const verifyResetPasswordCodeFail = () => ({
    type: actionTypes.VERIFY_RESET_PASSWORD_CODE_FAIL,
});

export const setResetPassword = ({ code, password }) => ({
    type: actionTypes.SET_RESET_PASSWORD,
    payload: {
        code,
        password,
    },
});

export const setResetPasswordSuccess = ({ accessToken }) => ({
    type: actionTypes.SET_RESET_PASSWORD_SUCCESS,
    accessToken,
});

export const setResetPasswordFail = () => ({
    type: actionTypes.SET_RESET_PASSWORD_FAIL,
});
